<template>
    <div class="EquipmentAcceptanceDetails">
        <van-overlay :show="show" @click="overlay()" />
        <Box title="设备验收信息">
            <div class="tabs">
                <div v-for="(item, index) in ['基本信息', '合同信息', '招标采购', '资金来源']"
                    :class="selectIndex === index ? 'action' : ''"
                    @click="selectIndex = index; $scrollscreen('.commonBox', 'start');">{{ item }}</div>
            </div>
            <div class="contentBox">
                <div class="firstBox" key="firstBox" v-if="selectIndex === 0">
                    <Field :Isdisabled="Isdisabled" name="EquipmentDictionariesNoText"
                        :ExistsTogether="{ Id: 'c', Name: '规格型号' }"
                        @manuconfirm="
                            AcceptanceInfoList.SBMCBH = arguments[0].a, AcceptanceInfoList.SBMC = arguments[0].b, AcceptanceInfoList.SBGG = arguments[0].c,
                            AcceptanceInfoList.SBDW = arguments[0].d, AcceptanceInfoList.KJKM = arguments[0].e, AcceptanceInfoList.KJKMMC = arguments[0].f"
                        title="设备名称" :action="true" :text="AcceptanceInfoList.SBMC" placeholder="请输入" type="manufacturer"
                        />
                    <!-- <Field :Isdisabled="Isdisabled" name="EquipmentDictionariesNoText"
                        :ExistsTogether="{ Id: 'c', Name: '规格型号' }"
                        @manuconfirm="
                            AcceptanceInfoList.SBMCBH = arguments[0].a, AcceptanceInfoList.SBMC = arguments[0].b, AcceptanceInfoList.SBGG = arguments[0].c,
                            AcceptanceInfoList.SBDW = arguments[0].d, AcceptanceInfoList.KJKM = arguments[0].e, AcceptanceInfoList.KJKMMC = arguments[0].f"
                        title="设备名称" :action="true" :text="AcceptanceInfoList.SBMC" placeholder="请输入" type="manufacturer"
                        @change="onChangeEventInfo(arguments[0].c)" /> -->

                    <Field name="equipmentClasses"
                        @manuconfirm="AcceptanceInfoList.KJKM = arguments[0].a, AcceptanceInfoList.KJKMMC = arguments[0].b"
                        title="资产分类" :action="true" :text="AcceptanceInfoList.KJKMMC" placeholder="请输入"
                        type="manufacturer" />

                    <Field title="数量" :action="true" placeholder="请输入" type='input' inputType='digit'
                        :text="AcceptanceInfoList.SL" @onMessage="AcceptanceInfoList.SL = arguments[0],
                            AcceptanceInfoList.ZJE = AcceptanceInfoList.CGDJ * arguments[0]" />
                    <Field title="单价" :action="true" placeholder="输入单价" type='input' inputType='number'
                        :text="AcceptanceInfoList.CGDJ" @onMessage="AcceptanceInfoList.CGDJ = arguments[0],
                            AcceptanceInfoList.ZJE = arguments[0] * AcceptanceInfoList.SL" />

                    <Field name="brand"
                        @manuconfirm="AcceptanceInfoList.SBPP = arguments[0].a, AcceptanceInfoList.PPMC = arguments[0].b"
                        title="品牌" :text="AcceptanceInfoList.PPMC" placeholder="请选择" type="manufacturer" />

                    <Field name="departmentList"
                        @manuconfirm="AcceptanceInfoList.JFKS = arguments[0].a, AcceptanceInfoList.JFKSMC = arguments[0].b"
                        title="验收科室" :text="AcceptanceInfoList.JFKSMC" placeholder="请选择" type="manufacturer" />

                    <Field name="countries"
                        @manuconfirm="AcceptanceInfoList.GB = arguments[0].a, AcceptanceInfoList.GBMC = arguments[0].b"
                        title="国别" :text="AcceptanceInfoList.GBMC" placeholder="请选择" type="manufacturer" />

                    <Field title="规格型号" :text="AcceptanceInfoList.SBGG"
                        @onMessage="value => AcceptanceInfoList.SBGG = value" type="text" />

                    <!-- <Field title="规格型号" id="GGXH" type="text" /> -->

                    <Field title="单位" placeholder="请输入" :text="AcceptanceInfoList.SBDW"
                        @onMessage="value => AcceptanceInfoList.SBDW = value" />



                    <Field title="注册证件号" placeholder="请输入" :text="AcceptanceInfoList.ZCZJH"
                        @onMessage="value => AcceptanceInfoList.ZCZJH = value" />
                    <Field title="出厂日期" placeholder="请选择" :text="AcceptanceInfoList.CCRQ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.CCRQ = value" />

                    <!-- 设备序列号区域 -->
                    <div class="xlh-section">
                        <div class="xlh-section-title" @click="poolExpanded = !poolExpanded">
                            设备序列号 <span class="xlh-count">({{ SBXLH_List.length }}条)</span>
                            <span class="xlh-toggle">{{ poolExpanded ? '收起' : '展开' }}</span>
                        </div>

                        <!-- 已选中的序列号（始终可见） -->
                        <div class='addbuttonParent'>
                            <div v-for="(item, index) in SBXLH_List" class="exist" :key="'sel'+index">
                                <p>{{ item.value }}
                                    <van-icon name="close" size='20' @click='DeletePopupItem(index, 1)' />
                                </p>
                                <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa' }" />
                            </div>

                            <!-- 可选序列号池（可折叠） -->
                            <div v-show="poolExpanded">
                                <template v-if="SBXLH_Pool.length > 0">
                                    <div class="pool-title">点击选择已有序列号：</div>
                                    <div v-for="(poolItem, pidx) in SBXLH_Pool"
                                        class="pool-item"
                                        :class="{ 'pool-selected': poolItem._selected }"
                                        :key="'pool'+pidx"
                                        @click="togglePoolItem(poolItem)">
                                        <span class="pool-check">{{ poolItem._selected ? '✓' : '' }}</span>
                                        <span>{{ poolItem.value }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="pool-empty">无预设序列号，请手动添加或扫码</div>
                                </template>
                            </div>

                            <!-- 操作按钮（始终可见） -->
                            <div class="addbutton" @click="ActionImport(1)">
                                <div>
                                    <van-icon name="add-o" size='20' /><span>手动添加</span>
                                </div>
                            </div>
                            <div class="addbutton" @click="ActionBarcode(1)">
                                <div>
                                    <van-icon name="scan" size='20' /><span>扫码识别</span>
                                </div>
                            </div>
                            <!-- 数量提示 -->
                            <div v-if="AcceptanceInfoList.SL && AcceptanceInfoList.SL > 0" class="xlh-count-tip">
                                数量：<strong>{{ SBXLH_List.length }} / {{ AcceptanceInfoList.SL }}</strong>
                            </div>
                        </div>
                    </div>
                    <!--  <Field title="设备序列号" placeholder="请输入" :text="AcceptanceInfoList.SBXLH"
                        @onMessage="value => AcceptanceInfoList.SBXLH = value" /> -->


                    <van-collapse v-model="actionCCBH">
                        <van-collapse-item title="出厂编号" title-class='title-class' :value='`${CCBH_List.length}条内容...`'
                            name="1">
                            <div class='addbuttonParent'>
                                <div v-for="(item, index) in CCBH_List" class="exist">
                                    <p>{{ item }}
                                        <van-icon name="close" size='20' @click='DeletePopupItem(index, 2)' />
                                    </p>
                                    <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa' }" />
                                </div>
                                <div class="addbutton" @click="ActionImport(2)">
                                    <div>
                                        <van-icon name="add-o" size='20' /><span>手动添加</span>
                                    </div>
                                </div>
                                <div class="addbutton" @click="ActionBarcode(2)">
                                    <div>
                                        <van-icon name="scan" size='20' /><span>扫码识别</span>
                                    </div>
                                </div>
                            </div>
                        </van-collapse-item>
                    </van-collapse>

                    <!-- <Field title="出厂编号" placeholder="请输入" :text="AcceptanceInfoList.CCBH"
                        @onMessage="value => AcceptanceInfoList.CCBH = value" /> -->

                    <Field name="equipmentTypeList"
                        @manuconfirm="AcceptanceInfoList.SBLX = arguments[0].a, AcceptanceInfoList.SBLXMC = arguments[0].b"
                        title="资产类型" :text="AcceptanceInfoList.SBLXMC" placeholder="请输入" type="manufacturer" />



                    <Field title="是否国产" :tabSelected="ISDomestic" type="teb"
                        :data="[{ id: '0', name: '国产' }, { id: '1', name: '进口' }, { id: '2', name: '未知' }]"
                        @onMessage="ISDomestic = arguments[0].id, ISDomesticMC = arguments[0].name" />

                    <Field title="管理类别" :tabSelected="AcceptanceInfoList.GLLB" type="teb"
                        :data="[{ id: '1', name: 'I' }, { id: '2', name: 'II' }, { id: '3', name: 'III' }]"
                        @onMessage="AcceptanceInfoList.GLLB = arguments[0].id" />

                    <Field title="急救资产" :tabSelected="AcceptanceInfoList.JJSBBZ" type="teb"
                        :data="[{ id: '1', name: '是' }, { id: '0', name: '否' }]"
                        @onMessage="AcceptanceInfoList.JJSBBZ = arguments[0].id" />

                    <Field title="特种资产" :tabSelected="AcceptanceInfoList.TZSBBZ" type="teb"
                        :data="[{ id: '1', name: '是' }, { id: '0', name: '否' }]"
                        @onMessage="AcceptanceInfoList.TZSBBZ = arguments[0].id" />

                    <Field title="计量资产" :tabSelected="AcceptanceInfoList.SFQJ" type="teb"
                        :data="[{ id: 'Y', name: '是' }, { id: 'N', name: '否' }]"
                        @onMessage="AcceptanceInfoList.SFQJ = arguments[0].id" />

                    <Field title="是否调配设备" :tabSelected="AcceptanceInfoList.GYSB" type="teb"
                        :data="[{ id: '1', name: '是' }, { id: '0', name: '否' }]"
                        @onMessage="AcceptanceInfoList.GYSB = arguments[0].id" />

                    <Field title="参与效益分析" :tabSelected="AcceptanceInfoList.SFCYXYFX" type="teb"
                        :data="[{ id: 'Y', name: '是' }, { id: 'N', name: '否' }]"
                        @onMessage="AcceptanceInfoList.SFCYXYFX = arguments[0].id" />

                    <Field title="说明书" :tabSelected="!!AZYS.find(x => x === 'g') ? 'g' : ''" type="teb"
                        :data="[{ id: 'g', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('g', arguments[0].id)" />
                    <Field title="保修卡" :tabSelected="!!AZYS.find(x => x === 'o') ? 'o' : ''" type="teb"
                        :data="[{ id: 'o', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('o', arguments[0].id)" />
                    <Field title="合格证" :tabSelected="!!AZYS.find(x => x === 'p') ? 'p' : ''" type="teb"
                        :data="[{ id: 'p', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('p', arguments[0].id)" />
                    <Field title="报关单" :tabSelected="!!AZYS.find(x => x === 'r') ? 'r' : ''" type="teb"
                        :data="[{ id: 'r', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('r', arguments[0].id)" />
                    <Field title="包装合格" :tabSelected="!!AZYS.find(x => x === 'b') ? 'b' : ''" type="teb"
                        :data="[{ id: 'b', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('b', arguments[0].id)" />
                    <Field title="验收合格" :tabSelected="!!AZYS.find(x => x === 'c') ? 'c' : ''" type="teb"
                        :data="[{ id: 'c', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('c', arguments[0].id)" />
                    <Field title="有无档案" :tabSelected="!!AZYS.find(x => x === 'd') ? 'd' : ''" type="teb"
                        :data="[{ id: 'd', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('d', arguments[0].id)" />
                    <Field title="是否网购" :tabSelected="!!AZYS.find(x => x === 'e') ? 'e' : ''" type="teb"
                        :data="[{ id: 'e', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('e', arguments[0].id)" />
                    <Field title="附属资料" :tabSelected="!!AZYS.find(x => x === 'f') ? 'f' : ''" type="teb"
                        :data="[{ id: 'f', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('f', arguments[0].id)" />
                    <Field title="检验报告书" :tabSelected="!!AZYS.find(x => x === 'q') ? 'q' : ''" type="teb"
                        :data="[{ id: 'q', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('q', arguments[0].id)" />
                    <Field title="实物与清单是否一致" :tabSelected="!!AZYS.find(x => x === 'a') ? 'a' : ''" type="teb"
                        :data="[{ id: 'a', name: '是' }, { id: '', name: '否' }]"
                        @onMessage="changeCheckBox('a', arguments[0].id)" />

                    <Field title="附资产标志" :tabSelected="AcceptanceInfoList.PJBZ" type="teb"
                        :data="[{ id: 'Y', name: '是' }, { id: 'N', name: '否' }]"
                        @onMessage="AcceptanceInfoList.PJBZ = arguments[0].id, AcceptanceInfoList.PJBZMC = arguments[0].name" />

                    <Field :ExistsTogether="{ Id: 'a', Name: '资产编号' }" v-if="AcceptanceInfoList.PJBZ === 'Y'"
                        name="assetsList"
                        @manuconfirm="AcceptanceInfoList.DDJXH = arguments[0].a, AcceptanceInfoList.ZCCMC = arguments[0].b"
                        title="主资产名称" :text="AcceptanceInfoList.ZCCMC" placeholder="请输入" type="manufacturer" />

                    <!-- <p class="itemTitle">附属类别</p>
                    <div class="checkBox">
                        <van-checkbox-group v-model="AcceptanceInfoList.FSLB">
                            <van-checkbox v-for="(item, index) in ['急救物资','特种资产','计量资产','是否公用设备','参与效益分析']" :name="item"
                                :key="index" checked-color="#4fa69e">{{item}}</van-checkbox>
                        </van-checkbox-group>
                    </div> -->
                    <p class="itemTitle">验收图片</p>
                    <ImgModule upload :disabled='$route.params.PageState' :deletable="!$route.params.PageState"
                        :img="accessoryModel" name="DABH" @afterRead="afterRead(arguments[0])"
                        @deleteImg="deleteImg(arguments[0])" title="" />
                </div>
                <div class="secondBox" key="secondBox1" v-if="selectIndex === 1">
                    <Field title="验收合格日期" :action="true" placeholder="请选择日期" :text="AcceptanceInfoList.YSHGRQ"
                        type="calendar" @onMessage="value => AcceptanceInfoList.YSHGRQ = value" />
                    <Field title="合同名称" placeholder="请输入合同名称" :text="AcceptanceInfoList.HTMC"
                        @onMessage="value => AcceptanceInfoList.HTMC = value" />
                    <Field title="签订日期" placeholder="请选择日期" :text="AcceptanceInfoList.QDRQ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.HTSJ = value" />
                    <Field title="总金额" placeholder="请输入合总金额" :text="AcceptanceInfoList.ZJE"
                        @onMessage="value => AcceptanceInfoList.ZJE = value" type="text" :readonly="true" />
                    <Field title="购入日期" placeholder="请选择日期" :text="AcceptanceInfoList.GRRQ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.GRRQ = value" />

                    <Field title="保修到期" placeholder="请选择日期" :DateMax='DateMax' :text="AcceptanceInfoList.BXRQ"
                        type="calendar" @onMessage="value => AcceptanceInfoList.YXRQ = value" />
                    <Field title="送审时间" placeholder="请选择日期" :DateMax='DateMax' :text="AcceptanceInfoList.SSRQ"
                        type="calendar" @onMessage="value => AcceptanceInfoList.SSSJ = value" />
                    <Field title="中标日期" placeholder="请选择日期"
                        :text="AcceptanceInfoList.ZBRQ === '1900-01-01' ? '' : AcceptanceInfoList.ZBRQ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.ZBRQ = value" />
                    <Field title="通知供货日期" placeholder="请选择日期" :DateMax='DateMax'
                        :text="AcceptanceInfoList.TZGHSJ === '1900-01-01' ? '' : AcceptanceInfoList.TZGHSJ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.TZGHSJ = value" />
                    <Field title="交货截止日期" placeholder="请选择日期" :DateMax='DateMax'
                        :text="AcceptanceInfoList.JHJZRQ === '1900-01-01' ? '' : AcceptanceInfoList.JHJZRQ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.JHJZRQ = value" />
                    <Field title="首次验收日期" placeholder="请选择日期"
                        :text="AcceptanceInfoList.SCYSRQ === '1900-01-01' ? '' : AcceptanceInfoList.SCYSRQ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.SCYSRQ = value" />
                    <Field title="二次验收日期" placeholder="请选择日期" :DateMax='DateMax'
                        :text="AcceptanceInfoList.ECYSRQ === '1900-01-01' ? '' : AcceptanceInfoList.ECYSRQ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.ECYSRQ = value" />
                </div>
                <div class="secondBox" key="secondBox2" v-if="selectIndex === 1">
                    <p class="title">合同信息</p>
                    <Field name="supplier" :action="true"
                        @manuconfirm="AcceptanceInfoList.SCQY = arguments[0].a, AcceptanceInfoList.SCQYMC = arguments[0].b"
                        title="生产厂家" :text="AcceptanceInfoList.SCQYMC" placeholder="请选择生产厂家" type="manufacturer" />
                    <Field name="manufacturer" :action="true" @manuconfirm="AcceptanceInfoList.GYSBH = arguments[0].a, AcceptanceInfoList.GYSMC = arguments[0].b, AcceptanceInfoList.GYSLXR = arguments[0].c,
                        AcceptanceInfoList.GYSDH = arguments[0].d" title="供应商" :text="AcceptanceInfoList.GYSMC"
                        placeholder="请输入" type="manufacturer" />
                    <Field title="供应商联系人" placeholder="请输入供应商联系人" :text="AcceptanceInfoList.GYSLXR"
                        @onMessage="value => AcceptanceInfoList.GYSLXR = value" />
                    <Field title="供应商联系电话" placeholder="请输入联系电话" :text="AcceptanceInfoList.GYSDH"
                        @onMessage="value => AcceptanceInfoList.GYSDH = value" type='input' inputType='number' />

                    <Field name="maintain" @manuconfirm="AcceptanceInfoList.WXGS = arguments[0].a, AcceptanceInfoList.WXGSMC = arguments[0].b, AcceptanceInfoList.WXRXM = arguments[0].c,
                        AcceptanceInfoList.WXLXDH = arguments[0].d" title="维修公司" :text="AcceptanceInfoList.WXGSMC"
                        placeholder="请输入" type="manufacturer" />
                    <Field title="维修联系人" placeholder="请输入维修联系人" :text="AcceptanceInfoList.WXLXR"
                        @onMessage="value => AcceptanceInfoList.WXLXR = value" />
                    <Field title="维修电话" placeholder="请输入维修电话" :text="AcceptanceInfoList.WXLXDH"
                        @onMessage="value => AcceptanceInfoList.WXLXDH = value" type='input' inputType='number' />
                </div>
                <div class="thirdlybox" key="thirdly" v-if="selectIndex === 2">
                    <Field name="procurementmethod"
                        @manuconfirm="AcceptanceInfoList.CGFS = arguments[0].a, AcceptanceInfoList.CGFSMC = arguments[0].b"
                        title="采购方式" :text="AcceptanceInfoList.CGFSMC" placeholder="请选择采购方式" type="manufacturer" />

                    <Field name="thetenderform"
                        @manuconfirm="AcceptanceInfoList.ZBXS = arguments[0].a, AcceptanceInfoList.ZBXSMC = arguments[0].b"
                        title="招标形式" :text="AcceptanceInfoList.ZBXSMC" placeholder="请选择招标形式" type="manufacturer" />

                    <Field title="单项预算" placeholder="请输入单项预算" :text="AcceptanceInfoList.DXYS"
                        @onMessage="value => AcceptanceInfoList.DXYS = value" type='input' inputType='number' />

                    <Field title="申请报告号" placeholder="请输入申请报告号" :text="AcceptanceInfoList.SQBGH"
                        @onMessage="value => AcceptanceInfoList.SQBGH = value" />
                    <Field title="参数送出时间" placeholder="请选择日期" :DateMax='DateMax'
                        :text="AcceptanceInfoList.JSSCSJ === '1900-01-01' ? '' : AcceptanceInfoList.JSSCSJ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.JSSCSJ = value" />
                    <Field title="论证时间" placeholder="请选择日期" :DateMax='DateMax'
                        :text="AcceptanceInfoList.LZSJ === '1900-01-01' ? '' : AcceptanceInfoList.LZSJ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.LZSJ = value" />
                    <Field title="安装日期" placeholder="请选择日期" :DateMax='DateMax'
                        :text="AcceptanceInfoList.AZRQ === '1900-01-01' ? '' : AcceptanceInfoList.AZRQ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.AZRQ = value" />
                    <Field title="发票编号" placeholder="请输入发票编号" :text="AcceptanceInfoList.FPBH"
                        @onMessage="value => AcceptanceInfoList.FPBH = value" />
                    <Field title="发票日期" placeholder="请选择日期" :DateMax='DateMax'
                        :text="AcceptanceInfoList.FPRQ === '1900-01-01' ? '' : AcceptanceInfoList.FPRQ" type="calendar"
                        @onMessage="value => AcceptanceInfoList.FPRQ = value" />
                    <Field title="立项依据" placeholder="请输入立项依据" type='textarea' :text="AcceptanceInfoList.LXYJ"
                        @onMessage="value => AcceptanceInfoList.LXYJ = value" />

                </div>
                <div class="fourthly" key="fourthly" v-if="selectIndex === 3">
                    <!-- 资金来源总计提示 -->
                    <div class="zjly-total">
                        <span>已填金额合计：</span>
                        <span class="zjly-total-money">{{ zjlyTotal }}</span>
                        <span>元</span>
                        <span class="zjly-total-price">/ 单价：{{ AcceptanceInfoList.CGDJ || 0 }} 元</span>
                    </div>

                    <!-- 动态资金来源列表 -->
                    <div v-for="(item, index) in zjlyList" :key="item.BH" class="fourthlyItems">
                        <div>
                            <span>{{ item.MC }}</span>
                            <input
                                type="number"
                                placeholder="请输入"
                                :value="item.money"
                                :disabled="Isdisabled"
                                @input="onZjlyMoneyInput(index, $event)"
                            >
                            <span>元</span>
                        </div>
                        <input
                            type="text"
                            placeholder="请输入备注内容"
                            v-model="item.bz"
                            :disabled="Isdisabled"
                        />
                    </div>

                    <!-- 加载中占位 -->
                    <div v-if="zjlyList.length === 0" class="zjly-loading">
                        <span>资金来源加载中...</span>
                    </div>
                </div>
            </div>
        </Box>
        <Footer v-if="!$route.params.PageState" button="保存" @change="save" />
        <van-popup v-model="ActionPopup" position='bottom'>
            <div class="popupDiv">
                <textarea ref="textarea" placeholder="请输入" v-model="popupTextarea"></textarea>
                <div class="popupButton">
                    <div @click='popupButtonClick'>确定</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import {
    LoadJurisdiction
} from '../../../tool/permission.js'
import {
    PresentType
} from '../../../config/index.js'
import Box from '../../components/commonBox/commonBox'
import Footer from '../../components/footer/footer'
import Field from '../../components/field/field'
import {
    Collapse,
    CollapseItem,
    CheckboxGroup,
    Checkbox,
    Icon,
    Divider,
    Popup,
    Field as Fields,
    Notify,
    Overlay
} from 'vant'
import ImgModule from '../../components/imgModule/imgModule'
export default {
    name: 'EquipmentAcceptanceDetails',
    components: {
        Box,
        Footer,
        Field,
        ImgModule,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Icon.name]: Icon,
        [Divider.name]: Divider,
        [Popup.name]: Popup,
        [Fields.name]: Fields,
        [Notify.name]: Notify,
        [Overlay.name]: Overlay
    },
    data() {
        return {
            actionXLH: ['1'], //设备序列号是否展开（默认展开）
            poolExpanded: true, // 序列号池是否展开（数量多时可折叠）
            actionCCBH: ['1'], //出厂编号是否展开（默认展开）
            DateMax: new Date(new Date().getFullYear() + 10, '01', '01'),
            ISDomestic: this.$route.params.AcceptanceInfoList.ISDomestic,
            ISDomesticMC: this.$route.params.AcceptanceInfoList.ISDomesticMC,
            tabIndex: '0',
            selectIndex: 0,
            action: 0,
            AcceptanceInfoList: this.$route.params.AcceptanceInfoList,
            AZYS: this.$route.params.AZYS,
            accessoryModelArray: [],
            accessoryModel: [], //图片集合
            Isdisabled: true, //控件是否禁用
            SBXLH_List: [], // 设备序列号选中列表 [{ id: number, value: string }]
            CCBH_List: [], // 出厂编号数组（保持字符串）
            SBXLH_Pool: [], // 可选序列号池（从设备已有数据加载）[{ id, value }]
            ActionPopup: false,
            ActionInputValue: '', //弹出层输入框值
            popupTextarea: '',
            typeValue: null, //弹出类型
            show: false, //遮罩层是否展示
            barcode: null, //扫描对象
            zjlyList: [], // 资金来源动态列表 [{ BH, MC, PYJM, money, bz }]

        }
    },
    computed: {
        zjlyTotal() {
            return this.zjlyList.reduce((sum, item) => sum + (parseFloat(item.money) || 0), 0);
        }
    },
    mounted() {
        if (!this.AcceptanceInfoList.hasOwnProperty('JFKS')) {
            this.$set(this.AcceptanceInfoList, 'JFKS', '');
            this.$set(this.AcceptanceInfoList, 'JFKSMC', '');
        }
        // 初始化序列号：从设备数据构建可选池和已选列表
        this.initSbxlhPool();

        // 兜底：如果 initSbxlhPool 没处理，尝试从 AcceptanceInfoList 直接回填 SBXLH_List
        if (this.SBXLH_List.length === 0 && this.AcceptanceInfoList && this.AcceptanceInfoList.SBXLH) {
            const savedArr = this.AcceptanceInfoList.SBXLH.split(',').map(v => v.trim()).filter(v => v);
            this.SBXLH_List = savedArr.map(val => ({ id: null, value: val }));
        }

        if (this.$route.params.AcceptanceInfoList.CCBH)
            this.CCBH_List = this.$route.params.AcceptanceInfoList.CCBH.split(',');

        if (this.$route.params.IsAddOrUpdata) this.loadAccessoryModel(this.AcceptanceInfoList.DH);
        else {
            this.Isdisabled = false;
            // 新建时默认填写当天日期
            if (!this.AcceptanceInfoList.YSHGRQ) {
                this.AcceptanceInfoList.YSHGRQ = this.$format(new Date(), 'YYYY-MM-DD');
            }
        }

        this.loadZjlyList();
    },
    methods: {
        save() {
            if (this.SBXLH_List.length != this.AcceptanceInfoList.SL && this.SBXLH_List.length != 0) {
                this.$Toast('设备序列号与数量不一致,请核对!')
                return false;
            }
            if (this.CCBH_List.length != this.AcceptanceInfoList.SL && this.CCBH_List.length != 0) {
                this.$Toast('出厂编号与数量不一致,请核对!')
                return false;
            }
            // 序列号：提取 value 拼接成字符串保存
            this.AcceptanceInfoList.SBXLH = this.SBXLH_List.map(x => x.value).join(',');
            // 序列号 ID 列表：id 非 null 的拼接
            const idStr = this.SBXLH_List.filter(x => x.id).map(x => x.id).join(',');
            this.AcceptanceInfoList.SBXLH_IDs = idStr || '';
            this.AcceptanceInfoList.CCBH = this.CCBH_List.join(',');
            if (!this.Exists([{
                propertyName: 'SBMCBH',
                position: 'start',
                page: 0,
                message: '请选择设备!',
                type: String
            },
            {
                propertyName: 'KJKM',
                position: 'start',
                page: 0,
                message: '请选择资产分类!',
                type: String
            },
            {
                propertyName: 'SL',
                position: 'start',
                page: 0,
                message: '请输入正确数量!',
                type: Number
            },
            {
                propertyName: 'CGDJ',
                position: 'start',
                page: 0,
                message: '请输入正确采购单价!',
                type: Number
            },
            {
                propertyName: 'SCQY',
                position: 'end',
                page: 1,
                message: '请选择生产厂家!',
                type: String
            },
            {
                propertyName: 'GYSBH',
                position: 'end',
                page: 1,
                message: '请选择供应商!',
                type: String
            },
            {
                propertyName: 'YSHGRQ',
                position: 'start',
                page: 1,
                message: '请选择验收合格日期!',
                type: String
            }
            ])) return;
            //验证完之后先上传图片信息
            let Serialnumber = this.$format(new Date(), 'YYYYMMDDHHmmss');

            let accessoryModel = this.accessoryModel;
            this.UpdataData();
        },
        UpdataData() {
            this.AcceptanceInfoList.ISDomestic = this.ISDomestic;
            this.AcceptanceInfoList.ISDomesticMC = this.ISDomesticMC;
            this.AcceptanceInfoList.AZYSQK = this.AZYS.join(',');
            this.$post('api/CheckIncoming/AddEquipment', {
                STORE: this.$UserInfo.StoreCode,
                GKHM: this.$UserInfo.UserId,
                YSBZ: 0,
                SHBZ: 0,
                Model: this.AcceptanceInfoList,
                ZJLYList: this.zjlyList.map((item, index) => ({
                    ZJLY: String(item.BH),
                    JE: String(parseFloat(item.money) || 0),
                    BZ: item.bz || '',
                    HH: index + 1,
                })),
            }).then(result => {
                if (result.Status) {
                    this.$Toast({
                        message: '验收信息保存成功!',
                        duration: 1500,
                        onClose: x => {
                            this.$router.back();
                        }
                    });
                } else { this.$Toast(result.Msg); }

            });
        },
        changeCheckBox(item, obj) {
            let vIndex = this.AZYS.findIndex(x => x === item);
            if (!!obj) vIndex != -1 ? '' : this.AZYS.push(item);
            else vIndex != -1 ? this.AZYS.splice(this.AZYS.findIndex(x => x === item), 1) : '';
        },
        // =================== 资金来源 ===================
        loadZjlyList() {
            // 未验收（新建）状态不传验收单号，其他情况以 QueryString 传递 DH
            const isNew = !this.$route.params.IsAddOrUpdata;
            const dh = isNew ? null : (this.AcceptanceInfoList.DH || null);
            const params = dh ? { YSDH: dh } : {};
            // 从接口获取可维护的资金来源类型列表
            this.$get('api/CheckIncoming/GetZJLYList', params).then(result => {
                let typeList = [];
                if (result && result.Status && Array.isArray(result.Data)) {
                    typeList = result.Data;
                } else if (Array.isArray(result)) {
                    typeList = result;
                }
                // 已有保存数据（编辑模式），尝试从 AcceptanceInfoList.ZJLYList 回填
                const savedList = this.AcceptanceInfoList.ZJLYList || [];
                let hasAnyMoney = false;
                this.zjlyList = typeList.map(type => {
                    const saved = savedList.find(s => s.BH === type.BH || s.PYJM === type.PYJM);
                    const money = saved ? (parseFloat(saved.JE) || 0) : 0;
                    if (money > 0) hasAnyMoney = true;
                    return {
                        BH: type.BH,
                        MC: type.MC,
                        PYJM: type.PYJM,
                        money: money,
                        bz: saved ? (saved.BZ || '') : '',
                    };
                });
                // 如果全部为 0 且设备单价存在，自动填充到第一条资金来源
                if (!hasAnyMoney && this.zjlyList.length > 0 && this.AcceptanceInfoList.CGDJ) {
                    this.$set(this.zjlyList, 0, { ...this.zjlyList[0], money: String(this.AcceptanceInfoList.CGDJ) });
                }
            }).catch(() => {
                this.$Toast('资金来源列表加载失败');
            });
        },
        onZjlyMoneyInput(index, event) {
            // 使用 $set 确保 Vue 响应式更新
            this.$set(this.zjlyList, index, {
                ...this.zjlyList[index],
                money: event.target.value,
            });
        },
        // =================== 资金来源 END ===================
        loadAccessoryModel(DH) { //获取验收图片
            this.$get('api/CheckIncoming/AcceptanceImgList', {
                DH: DH ? DH : '',
                LSDH: this.$route.params.AcceptanceInfoList.LSBH
            }).then(result => {
                if (result.Status) {
                    this.accessoryModelArray = result.ImgList;
                    this.accessoryModel = [];
                    for (let i = 0; i < result.ImgList.length; i++) {
                        this.accessoryModel.push({
                            DABH: result.ImgList[i].DABH,
                            url: result.ImgList[i].RePath
                        });
                    }
                    this.$Bus.$emit('YSRKDelete', this.accessoryModel);
                } else { this.$Toast(result.Msg); }
            });
        },
        afterRead(Value) {
            let params = {};
            let Serialnumber = this.$format(new Date(), 'YYYYMMDDHHmmss');
            Value instanceof Array ? params = {
                base64Str1: 1 <= Value.length ? Value[0].content : '',
                base64Str2: 2 <= Value.length ? Value[1].content : '',
                base64Str3: 3 <= Value.length ? Value[2].content : '',
                base64Str4: 4 <= Value.length ? Value[3].content : '',
                base64Str5: 5 <= Value.length ? Value[4].content : '',
                base64Str6: 6 <= Value.length ? Value[5].content : '',
                base64Str7: 7 <= Value.length ? Value[6].content : '',
                base64Str8: 8 <= Value.length ? Value[7].content : '',
                base64Str9: 9 <= Value.length ? Value[8].content : '',
                base64Str10: 10 <= Value.length ? Value[9].content : '',
                DH: this.$route.params.IsAddOrUpdata ? this.AcceptanceInfoList.DH : '',
                DABH: Serialnumber,
                DAMC: Serialnumber,
                BZ: '',
                ZHXGR: this.$UserInfo.UserId,
                LSBH: this.AcceptanceInfoList.LSBH,
            } : params = {
                base64Str1: Value.content,
                DH: this.$route.params.IsAddOrUpdata ? this.AcceptanceInfoList.DH : '',
                DABH: Serialnumber,
                DAMC: Serialnumber,
                BZ: '',
                ZHXGR: this.$UserInfo.UserId,
                LSBH: this.AcceptanceInfoList.LSBH,
            };

            this.$post('api/CheckIncoming/UploadAcceptanceImg', params,{timeout:100000}).then(result => {
                if (result.Status) {
                    this.$Toast({
                        message: '图片上传成功!',
                        duration: 1500,
                        onClose: x => {
                            this.loadAccessoryModel(this.AcceptanceInfoList.DH);
                        }
                    });
                } else { this.$Toast(result.Msg); }
            });
        },
        deleteImg(Value) {
            let Index = this.accessoryModelArray.findIndex(x => x.DABH === Value.DABH);
            const obj = this.accessoryModelArray[Index];
            this.$Dialog.confirm({
                message: '确定删除?'
            }).then(() => {
                this.$get('api/CheckIncoming/DelAcceptanceImg', {
                    DH: obj.DH,
                    DABH: Value.DABH,
                    LSBH: obj.LSBH,
                    DALJ: obj.DALJ,
                }).then(result => {
                    if (result.Status) {
                        this.loadAccessoryModel(this.AcceptanceInfoList.DH); //重新加载
                        this.$Toast('删除成功!');
                    }
                })
            }).catch(() => { });
        },
        Exists(object) { //提交验证方法
            for (let i = 0; i < object.length; i++) {
                let data = object[i];
                if (data.type === String) {
                    if (!this.AcceptanceInfoList[data.propertyName]) {
                        this.$Toast(data.message);
                        this.selectIndex = data.page;
                        this.$scrollscreen('.commonBox', data.position);
                        return false
                    }
                } else if (data.type === Number) {
                    if (this.AcceptanceInfoList[data.propertyName] === undefined || this.AcceptanceInfoList[data
                        .propertyName] ==
                        0) {
                        this.$Toast(data.message);
                        this.selectIndex = data.page;
                        this.$scrollscreen('.commonBox', data.position);
                        return false
                    }
                }
            }
            const Money = this.zjlyTotal;
            if (this.AcceptanceInfoList.CGDJ != Money) {
                this.$Toast('资金来源总价与单价不符！');
                this.selectIndex = 3;
                this.$scrollscreen('.commonBox', 'start');
                return false;
            }
            return true;
        },
        ActionImport(type) { //弹出输入框
            this.typeValue = type;
            this.ActionPopup = true;
            this.$nextTick(() => {
                this.$refs.textarea.focus();
            })
        },
        popupButtonClick() {
            if (!this.popupTextarea) {
                this.$Toast('请输入，再进行操作!');
                return false;
            }
            if (this.typeValue == 1) {
                // 序列号：检查唯一性
                if (this.SBXLH_List.some(x => x.value === this.popupTextarea)) {
                    this.$Toast('已存在当前输入值！');
                    return false;
                }
                if (this.AcceptanceInfoList.SL && this.SBXLH_List.length >= parseFloat(this.AcceptanceInfoList.SL)) {
                    this.$Toast(`已达到数量上限 ${this.AcceptanceInfoList.SL}`);
                    return;
                }
                // 手动添加的序列号 id 为 null
                this.SBXLH_List.push({ id: null, value: this.popupTextarea });
            } else {
                if (this.CCBH_List.includes(this.popupTextarea)) {
                    this.$Toast('已存在当前输入值！');
                    return false;
                }
                this.CCBH_List.push(this.popupTextarea);
            }
            this.popupTextarea = '';
            Notify({
                message: '添加成功!',
                color: '#F7F8FA',
                background: '#07C160'
            });
            this.$refs.textarea.focus();
        },
        initSbxlhPool() { // 从设备数据构建序列号可选池 + 已选列表
            // 优先读 SBXLHS（设备预设的全部序列号），其次读 SBXLH（已保存的选中序列号）
            const raw = (this.AcceptanceInfoList.SBXLHS || this.AcceptanceInfoList.SBXLH || '').trim();
            // 兼容不同大小写的字段名
            const rawId = (
                this.AcceptanceInfoList.SBXLHIDStr ||
                this.AcceptanceInfoList.SBXLHIdStr ||
                this.AcceptanceInfoList.SBXLHIDSTR ||
                ''
            ).trim();
            if (!raw) return;
            const values = raw.split(',').map(v => v.trim()).filter(v => v);
            const ids = rawId ? rawId.split(',').map(v => v.trim()).filter(Boolean) : [];
            // 构建可选池（全部同步到 pool，再标记已选中）
            this.SBXLH_Pool = values.map((val, idx) => ({
                id: ids[idx] || null,
                value: val,
                _selected: false,
            }));
            // 回填：新建时全不选；编辑时以已保存的 SBXLH 为准
            const saved = (this.AcceptanceInfoList.SBXLH || '').trim();
            if (saved) {
                // 编辑模式：已保存的序列号字符串 → 回填到 SBXLH_List
                const savedArr = saved.split(',').map(v => v.trim()).filter(Boolean);
                this.SBXLH_List = savedArr.map(val => {
                    const poolIdx = this.SBXLH_Pool.findIndex(p => p.value === val);
                    if (poolIdx !== -1) {
                        this.$set(this.SBXLH_Pool[poolIdx], '_selected', true);
                        return { id: this.SBXLH_Pool[poolIdx].id, value: val };
                    }
                    return { id: null, value: val }; // 说明是手动添加的，不在池里
                });
            }
            // 新建且无序列号字段时：SBXLH_Pool 为空，用户可以手动输入/扫码
        },
        DeletePopupItem(index, type) { //删除项
            if (type == 1) {
                // 从选中列表移除，同时将可选池中对应的恢复为未选
                const removed = this.SBXLH_List[index];
                if (removed && removed.id) {
                    const poolItem = this.SBXLH_Pool.find(p => p.id === removed.id);
                    if (poolItem) this.$set(poolItem, '_selected', false);
                }
                this.SBXLH_List.splice(index, 1);
            } else {
                this.CCBH_List.splice(index, 1);
            }
        },
        togglePoolItem(poolItem) { // 切换可选池中的序列号
            if (!poolItem._selected) {
                // 选中：检查数量上限
                if (this.AcceptanceInfoList.SL && this.SBXLH_List.length >= parseFloat(this.AcceptanceInfoList.SL)) {
                    this.$Toast(`已达到数量上限 ${this.AcceptanceInfoList.SL}`);
                    return;
                }
                // 检查唯一性
                if (this.SBXLH_List.some(x => x.value === poolItem.value || x.id === poolItem.id)) return;
                this.SBXLH_List.push({ id: poolItem.id, value: poolItem.value });
                this.$set(poolItem, '_selected', true);
            } else {
                // 取消选中
                const idx = this.SBXLH_List.findIndex(x => x.id === poolItem.id);
                if (idx !== -1) this.SBXLH_List.splice(idx, 1);
                this.$set(poolItem, '_selected', false);
            }
        },
        ActionBarcode(type) { //扫码识别
            this.typeValue = type;
            if (PresentType) {
                this.$Toast('当前环境暂不支持扫码！');
                return false;
            }
            var that = this;
            LoadJurisdiction({
                Android: 'android.permission.CAMERA',
                Ios: 'camera',
                Message: '请在权限管理赋予APP摄像头权限',
            }).then(() => {
                if (!that.barcode) {
                    that.barcode = plus.barcode.create('barcode', [plus.barcode.EAN13, plus.barcode.EAN8], {
                        top: '0px',
                        left: '0px',
                        width: '100%',
                        height: '500px',
                        position: 'absolute'
                    });
                }

                this.show = true;
                plus.webview.currentWebview().append(that.barcode);
                that.$Mui.back = () => {
                    if (that.barcode) {
                        that.barcode.close();
                        that.barcode = null;
                        that.show = false;
                    } else {
                        that.$router.back();
                    }
                }
                that.barcode.onmarked = function (e, result) {
                    if (type == 1) {
                        if (that.SBXLH_List.some(x => x.value === result)) {
                            that.$Toast('已存在该设备序列号!');
                            return false;
                        }
                        if (that.AcceptanceInfoList.SL && that.SBXLH_List.length >= parseFloat(that.AcceptanceInfoList.SL)) {
                            that.$Toast(`已达到数量上限 ${that.AcceptanceInfoList.SL}`);
                            that.barcode.close();
                            return false;
                        }
                        that.SBXLH_List.push({ id: null, value: result });
                    } else {
                        if (that.CCBH_List.includes(result)) {
                            that.$Toast('已存在该出厂编号!');
                            return false;
                        }
                        that.CCBH_List.push(result);
                    }
                    that.barcode.close();
                };
                that.barcode.onerror = function (error) {
                    that.barcode.close();
                    that.$Toast(`扫码出现异常:${error}`);
                }
                that.barcode.start();
            })

        },
        overlay() {
            if (this.barcode) {
                this.barcode.close();
                this.barcode = null;
                this.show = false;
            }
        },
        menuClick(data) {

        },
    }
}
</script>

<style scoped lang="scss">
.EquipmentAcceptanceDetails {
    padding-bottom: 112px;
}

.tabs {
    display: flex;
    align-items: center;
    background: #45918A;
    border-radius: 14px 14px 0 0;
    position: fixed;
    z-index: 10;
    top: 105px;

    div {
        width: 177.5px;
        height: 96px;
        text-align: center;
        line-height: 96px;
        font-size: 28px;
        color: rgba(255, 255, 255, .7);
        border-radius: 14px 14px 0 0;
    }

    .action {
        color: $THEME-COLOR;
        background: #fff;
    }
}

.contentBox {
    margin-top: 85px;

    &>div {
        padding: 0 30px;
        border-radius: 14px;
        background: #fff;
        margin-bottom: 30px;

        &:first-child {
            border-radius: 14px;
        }
    }
}

.itemTitle {
    font-size: 30px;
    color: $TEXT-DARK-COLOR;
    margin: 38px 0;
}

.checkBox {
    &>div>div {
        height: 90px;
        border-bottom: 2px solid #f3f3f3;
        font-size: 28px;
        color: $TEXT-DARK-COLOR;
    }
}

.firstBox {
    padding-bottom: 20px !important;
}

.firstBox>div:last-child {
    padding: 0;
}

.secondBox {
    .title {
        font-size: 32px;
        color: $TEXT-DARK-COLOR;
        font-weight: bold;
        padding-top: 44px;
    }
}

.fourthly {
    padding: 34px 36px 12px !important;
}

.zjly-total {
    display: flex;
    align-items: center;
    background: #EBF3FF;
    border-radius: 12px;
    padding: 18px 24px;
    margin-bottom: 32px;
    font-size: 28px;
    color: #333;

    .zjly-total-money {
        font-size: 32px;
        font-weight: bold;
        color: #1989fa;
        margin: 0 6px;
    }

    .zjly-total-price {
        margin-left: auto;
        font-size: 26px;
        color: #888;
    }
}

.zjly-loading {
    text-align: center;
    color: #aaa;
    font-size: 28px;
    padding: 40px 0;
}

.fourthlyItems {
    margin-bottom: 36px;

    div {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        span:first-child {
            flex: 1;
            font-size: 30px;
            color: $TEXT-DARK-COLOR;
        }

        span:last-child {
            font-size: 28px;
            color: $TEXT-DARK-COLOR;
            margin-left: 10px;
        }

        input {
            font-size: 32px;
            font-weight: bold;
            text-align: right;
            background-color: #F3F3F3;
            padding-right: 15px;

            &::-webkit-input-placeholder {
                color: #858585;
                font-size: 28px;
                font-weight: 400;
            }
        }
    }

    &>input {
        width: 650px;
        height: 88px;
        background: #F3F3F3;

        border-radius: 12px;
        font-size: 26px;
        text-indent: 32px;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }
}

.addbuttonParent {
    .addbutton {
        height: 10vw;
        background-color: #1777FF;
        color: white;
        width: 49%;
        display: inline-block;
        text-align: center;
        border-radius: 0.5em;

        div {
            position: relative;
            top: 1.8vw;
        }

        span {
            position: relative;
            bottom: 1vw;
        }
    }

    .exist {
        p {
            width: 92%;

            i {
                float: right;
            }
        }

        width: 100%;
        // background-color:#;
    }
}

.addbuttonParent .addbutton:last-child {
    background-color: #D54B28;
}

.xlh-section {
    background: #fff;
    border-radius: 12px;
    padding: 24px 30px;
    margin-bottom: 24px;
}
.xlh-section-title {
    font-size: 30px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .xlh-count {
        font-size: 24px;
        color: #1989fa;
        margin-left: 12px;
        font-weight: normal;
    }

    .xlh-toggle {
        margin-left: auto;
        font-size: 24px;
        color: #1989fa;
        font-weight: normal;
    }
}

.pool-title {
    font-size: 24px;
    color: #858585;
    margin: 20px 0 10px;
    padding-top: 16px;
    border-top: 1px solid #eee;
}

.pool-item {
    display: flex;
    align-items: center;
    padding: 16px 12px;
    border-bottom: 1px solid #eee;
    font-size: 28px;
    color: #333;
    transition: all 0.15s;

    &:active {
        background: #f5f5f5;
    }

    &.pool-selected {
        color: #1989fa;
        background: #f0f8ff;
        border-radius: 8px;
    }

    .pool-check {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border: 2px solid #ccc;
        border-radius: 8px;
        margin-right: 16px;
        font-size: 28px;
        color: #1989fa;
        font-weight: bold;
    }

    &.pool-selected .pool-check {
        background: #1989fa;
        border-color: #1989fa;
        color: #fff;
    }
}

.xlh-count-tip {
    margin-top: 20px;
    font-size: 24px;
    color: #ff976a;
    strong {
        font-size: 28px;
    }
}

.pool-empty {
    text-align: center;
    color: #ccc;
    font-size: 24px;
    padding: 24px 0;
}

.popupDiv {
    textarea {
        padding-top: 10px;
        height: 21vw;
        width: 98%;
    }

    .popupButton {
        div {
            background-color: white;
            height: 50px;
        }

        text-align: center;
        background-color: #C0C0C0;
        padding: 9px 0;
        height: 50px;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/equipmentAcceptanceDetails/equipmentAcceptanceDetails.vue